/**
 * Application Constants
 * 
 * Centralized constants for the entire application
 */

import * as FEEDBACK_CONSTANTS from './feedback';
import * as TIMING_CONSTANTS from './timing';
import * as GAMEPLAY_CONSTANTS from './gameplay';
import * as AUDIO_CONSTANTS from './audio';

export const FEEDBACK_TYPES = FEEDBACK_CONSTANTS.FEEDBACK_TYPES;
export const FEEDBACK_TIMEOUTS = FEEDBACK_CONSTANTS.FEEDBACK_TIMEOUTS;
export const CONFETTI_CONFIG = FEEDBACK_CONSTANTS.CONFETTI_CONFIG;
export const ENCOURAGING_MESSAGES = FEEDBACK_CONSTANTS.ENCOURAGING_MESSAGES;
export const FEEDBACK_CONFIGS = FEEDBACK_CONSTANTS.FEEDBACK_CONFIGS;

// Timing constants
export const TIMEOUTS = TIMING_CONSTANTS.TIMEOUTS;
export const RESPONSE_TIMES = TIMING_CONSTANTS.RESPONSE_TIMES;
export const ONE_DAY_MS = TIMING_CONSTANTS.ONE_DAY_MS;
export const ONE_WEEK_MS = TIMING_CONSTANTS.ONE_WEEK_MS;

// Gameplay constants
export const SCORE_THRESHOLDS = GAMEPLAY_CONSTANTS.SCORE_THRESHOLDS;
export const SCORING = GAMEPLAY_CONSTANTS.SCORING;
export const QUESTION_LIMITS = GAMEPLAY_CONSTANTS.QUESTION_LIMITS;
export const ACHIEVEMENT_THRESHOLDS = GAMEPLAY_CONSTANTS.ACHIEVEMENT_THRESHOLDS;
export const UNLOCK_THRESHOLDS = GAMEPLAY_CONSTANTS.UNLOCK_THRESHOLDS;
export const PROGRESS_THRESHOLDS = GAMEPLAY_CONSTANTS.PROGRESS_THRESHOLDS;
export const TIME_THRESHOLDS = GAMEPLAY_CONSTANTS.TIME_THRESHOLDS;
export const RATING = GAMEPLAY_CONSTANTS.RATING;
export const RECENT_SCORES_MIN_COUNT = GAMEPLAY_CONSTANTS.RECENT_SCORES_MIN_COUNT;
export const NETWORK_RETRY = GAMEPLAY_CONSTANTS.NETWORK_RETRY;
export const REWARD_POINTS = GAMEPLAY_CONSTANTS.REWARD_POINTS;

// Audio constants
export const SOUND_TYPES = AUDIO_CONSTANTS.SOUND_TYPES;
export const AUDIO_EVENTS = AUDIO_CONSTANTS.AUDIO_EVENTS;
export const HAPTIC_TYPES = AUDIO_CONSTANTS.HAPTIC_TYPES;

// Subject Names
export const SUBJECTS = {
  PHONICS: 'phonics',
  MATH: 'math',
  READING: 'reading',
  SPELLING: 'spelling',
  SCIENCE: 'science',
  ART: 'art',
  GEOGRAPHY: 'geography',
  HISTORY: 'history',
  SOCIAL: 'social',
  CITIZENSHIP: 'citizenship',
  SKIP_COUNTING: 'skipCounting'
};

// Game Screen Identifiers
export const GAME_SCREENS = {
  HOME: 'home',
  PHONICS: 'phonics',
  MATH: 'math',
  READING: 'reading',
  SPELLING: 'spelling',
  SCIENCE: 'science',
  ART: 'art',
  GEOGRAPHY: 'geography',
  HISTORY: 'history'
};

// All subject keys as array (useful for iteration)
export const ALL_SUBJECTS = [
  SUBJECTS.PHONICS,
  SUBJECTS.MATH,
  SUBJECTS.READING,
  SUBJECTS.SPELLING,
  SUBJECTS.SCIENCE,
  SUBJECTS.ART,
  SUBJECTS.GEOGRAPHY,
  SUBJECTS.HISTORY
];

// Animation Constants
export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
  VERY_SLOW: 1000
};

// Z-Index Layers
export const Z_INDEX = {
  BASE: 0,
  DROPDOWN: 10,
  STICKY: 20,
  OVERLAY: 30,
  MODAL: 40,
  TOOLTIP: 50,
  TOAST: 60
};

// Breakpoints (for consistency)
export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536
};

// Common Delays
export const DELAYS = {
  SHORT: 100,
  MEDIUM: 300,
  LONG: 500,
  DEBOUNCE: 300,
  THROTTLE: 100
};

